import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let DataAnalysisApi = class DataAnalysisApi {
    constructor(http) {
        this.http = http;
    }
};
DataAnalysisApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __metadata("design:paramtypes", [Object])
], DataAnalysisApi);
export { DataAnalysisApi };
